import { Breakpoints } from './tokens';

export const breakpoints = Breakpoints;
